export default {
  registration: {
    headline: "Registration",
    headline_desc: "Enter your details below to register your Competo account.",
    back_to_login: "Back to login",
    register: "Register",
    view: "View",
    close: "Close",
    agreement: "This field is required.",
    description: {
      basic: "Basic information",
      current_employment: "Current employment data",
      wanted_employment: "Desired employment info"
    },
    loading_cv: "Processing CV...",
    loading_cv_description: "Data from CV may fill in empty fields in the form.",
    fields: {
      name: {
        label: "Name and last name"
      },
      gender: {
        label: "Sex"
      },
      education: {
        label: "Level of education"
      },
      birthday: {
        label: "Date of Birth",
        info: "Date of birth is needed for the processing and normalization of anonymized data."
      },
      career: {
        label: "Current career level"
      },
      email: {
        label: "E-mail"
      },
      password: {
        label: "Password"
      },
      confirm_password: {
        label: "Confirm password"
      },
      cv: {
        label: "CV",
        description: "You have not attached your CV. This is an essential document for applying for a job."
      },
      linkedin_url: {
        label: "LinkedIn link"
      },
      employer: {
        label: "Current employer"
      },
      industries: {
        label: "Industry"
      },
      workfields: {
        label: "Field of work"
      },
      expectations: {
        label: "Desired annual gross salary (EUR)"
      },
      region: {
        label: "Region"
      },
      phone: {
        label: "Phone"
      },
      position_title: {
        label: "Job title"
      },
      address: {
        label: "Street and house number"
      },
      city: {
        label: "City"
      },
      postal: {
        label: "Postal address"
      },
      country: {
        label: "Country"
      },
      education_summary: {
        label: "Title and educational institution achieved"
      },
      notice_days: {
        label: "Notice period (days)"
      }
    },
    gender: {
      male: "Male",
      female: "Female"
    },
    password_rule: "Password has to be at least 6 characters long <br/> and contain at least one uppercase letter, lowercase letter, number and special character",
    confirm_error: "The password confirmation does not match.",
    error: "An error occured during registration process"
  },
  registration_intro: {
    headline: "Work with us as a Fractional Executive",
    headline_desc: "Your leadership experience can create value in more than one company.",
    network: {
      building: "Competo is building a carefully selected network of experienced leaders who want to put their knowledge and experience to work through fractional executive engagements – leading growth, transformation, internationalisation and other key business challenges.",
      invitation: "Into the Competo Executive network we invite experienced C-level leaders, general managers, managing directors and functional directors with a proven record of business results, who are interested in a more flexible, project-based way of continuing their career."
    },
    interests: {
      title: "What are we interested in?",
      lead: "Beyond your experience so far, we mainly want to understand:",
      items: {
        value: "the areas where you can create the greatest added value,",
        challenges: "the business challenges you have successfully solved,",
        projects: "the kinds of projects and companies that interest you,",
        commitment: "how much time you want to devote to fractional engagements,",
        markets: "the markets you are willing to work in."
      }
    },
    next_steps: {
      title: "What happens after you apply?",
      not_automatic: "Applying does not mean automatic inclusion in Competo Executive.",
      interview: "After reviewing your profile, if we see suitable potential for working together, we will invite you to a personal conversation. Together we will define your key competences, experience and the areas where you can create the greatest value as a Fractional Executive.",
      opportunity: "When a project matching your profile comes up, we will contact you and present the opportunity. You decide whether the engagement interests you.",
      confidentiality: "We will treat your details and your profile confidentially and will not present them to potential clients without your prior consent."
    },
    closing: {
      next_phase: "The next phase of your career can look different. It does not have to mean a new full-time role. It can be an opportunity to use your experience where it is needed most at a given moment.",
      invitation: "Tell us about your experience and interests."
    },
    start: "Start your application",
    back_to_login: "Back to login"
  },
  registration_success: {
    title_success: "Registration successful",
    thank_you_note: "Thank you for registering in the database of job seekers.",
    confirmation: "For a successful registration, we need your confirmation, which you received by email."
  },
  activation: {
    headline: "Activating account",
    headline_desc: "Your account is being activated. You will be redirected shortly..."
  },
  activation_success: {
    headline: "Account activated",
    headline_desc: "Your account has been activated! You can proceed to login.",
    to_login: "To login"
  },
  activation_error: {
    headline: "Account activation error",
    headline_desc: "There was an issue with activating your account.",
    error_msg: "Error message:",
    contact: "Please contact the administrator for more information."
  }
}
